import React from "react"
import {FieldManagementFormProps} from "../../../../render/management-form";
import FormManager from "../../../../../gd-form/common/form-manager";
import ErrorBoundary from "../../../../../error-boundary";
import FieldManagementLeftPanel from "../../../../proto/render/management/panel/form-left-panel";
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import FormRow from "../../../../../gd-form/form/form-ui5/form-row";
import Input from "../../../../../gd-form/form-element/input/input";
import FormError from "../../../../../gd-form/common/form-error/form-error";
// @ts-ignore
import CustomField_FormRowAccess from "../../../../../fields/custom/common/form-access-new"
import ButtonSubmitDeprecated from "../../../../../gd-form/common/btn-submit/btn-submit-ui5";
import CustomField_FromRowScope from "../../../../../fields/custom/common/form-scope";
import {CustomFieldScope} from "../../../../../gd/const/fields/custom-fields-v1-const";
import {FieldManagementFormCFV1Props} from "../../../../render/management-form-cf-v1";

// type Props = {
//     field       : FieldProto
//     onSubmit    : callback
//     entity      : EntityType // entity type we create this CF for - is set marked as required
// }

const debug = "FieldReaction_ManagementFormCFV1"
// const debug = false

export default class FieldReaction_ManagementFormCFV1 extends React.Component<FieldManagementFormCFV1Props> {

    public form         : FormManager

    constructor(props:FieldManagementFormProps) {
        super(props)

        const initFormData = {
            label           : this.props.field.label || '',
            description     : _.get(this.props, 'field.description', ''),
            fieldAccess     : _.get(this.props, 'field.fieldAccess', gd.const.customFields.access.EVERYONE),
            scope           : this.props.field.fieldParams.scope
        }

        const formStructure = {
            fields: {
                label       : {
                    type: 'input',
                    isRequired: true,
                    label: 'Label',
                    validator: (val:any) => {
                        let res:any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'Invalid label';
                        }
                        return res;
                    }
                },
                // description : { type: 'input',      isRequired: false,  label: 'Description'},
                fieldAccess : { type: 'select',     isRequired: true,   label: 'Access'},
                // isRequired  : { type: 'boolean',    isRequired: false,  label: 'Is required'},

                scope       : {
                    type        : 'input',
                    isRequired  : true
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onSubmit = (result:any) => {
        debug && console.log(debug, 'onSubmit', result)

        this.props.field.label          = result.label.trim()
        // this.props.field.description    = result.description.trim()
        // this.props.field.isRequired     = !!result.isRequired
        this.props.field.fieldAccess    = result.fieldAccess

        this.props.field.fieldParams    = {
            scope       : result.scope
        }

        debug && console.log(debug, 'onSubmit field', this.props.field)

        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field);
    }


    render() {

        const mandatoryScope : CustomFieldScope[] = []


        return (
            <React.Fragment>
                <ErrorBoundary>
                    <FieldManagementLeftPanel field={this.props.field} />
                </ErrorBoundary>

                <ErrorBoundary>


                    <div className="iv-cf-form">
                        <VScroll className="iv-cf-scroll">

                            <div className="iv-header header-left header-small-no-separator">
                                <div className="title-line">
                                    <div className="view-name">
                                        <div className="ui5-title-app-name max-w-350 ">New Custom Field</div>
                                    </div>
                                </div>
                            </div>

                            <div className="iv-content with-left-panel">
                                <div className="p-l-30">
                                    <div className="ui5-form size-30-70">
                                        <div className="f-tbl">

                                            <FormRow label="Name">
                                                <Input size="big" form={this.form} name="label"/>
                                                <FormError form={this.form} name="label" />
                                            </FormRow>


                                            <CustomField_FormRowAccess form={this.form}/>

                                            <CustomField_FromRowScope form={this.form} mandatoryScope={this.props.mandatoryScope || []}/>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VScroll>

                        <div className="bottom-action">
                            <ButtonSubmitDeprecated form={this.form} className="submit" label="Save"/>
                        </div>


                    </div>




                </ErrorBoundary>
            </React.Fragment>
        )
    }

}